import { MessagePlusIcon } from './MessagePlusIcon';

/**
 * author: Simran
 * id C0B4CC94-B6B5-462F-93C2-98F07093614C
 * name message-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-plus.svg
 * tags
 */
export const MessageAddIcon = MessagePlusIcon;
export default MessageAddIcon